export const playlistKeys = {
    all: ["playlists"] as const,
    user: (userId: string) => [...playlistKeys.all, "user", userId] as const,
    detail: (playlistId: string) => [...playlistKeys.all, "detail", playlistId] as const,
    songs: (playlistId: string) => [...playlistKeys.detail(playlistId), "songs"] as const,
};
